module.exports = __webpack_public_path__ + "img/popup.cfbfa53c.png";